export default {
  primary: '#5003AF',
  primaryDark: '#29005E',
  secondary: '#D8690F',
};
